module.exports = __webpack_public_path__ + "img/RZ_RGB_QUA-LiS-Logo-Supportstelle_pfade.4060b5fa.png";